import type { InstallationFlowLocale } from "@/locales/fr/installation-flow";

import { ESiteBonusTransferStatus } from "@/types/backoffice/dto/bonus-offer/site-bonus-transfer-dto";

const installationFlowLocale: InstallationFlowLocale = {
  installationFlow: {
    widgetTitle: "Installation status",
    flow: {
      fieldName: "Method",
      provision: "Provision of services",
      sale: "Sale",
    },
    status: {
      fieldName: "Status",
      done: "Completed",
      ongoing: "Ongoing",
      canceled: "Canceled",
      pending: "An error occurred during the sign request",
      error: "Error",
    },
    esc: {
      preInterventionEscQuote: "Pre-intervention quote",
      escPackage: "ESC package",
      validate: "Validate ESC file",
      validateSuccess: "ESC file validated",
      waitingValidation: "Waiting for validation",
      validated: "Validated",
      signed: "Signed",
      quoteUploadDate: "Quote uploaded on",
      sendCustomerServiceCertificate: "Send customer service certificate",
    },
    is: {
      installationSheet: "Installation sheet",
      signed: "Signed",
      uploadDate: "Sheet uploaded on",
      notUploaded: "Waiting for sheet to be uploaded",
      upgradeToEsc: "Generate a new ESC signature request",
    },
    signature: {
      sendReminder: "Send a reminder for the signature request",
      sendReminderSuccess: "Request for signature resent",
      requestDate: "Signature requested on",
      cancel: "Cancel signature request",
      canceled: "Signature canceled",
      cancelSuccess: "Cancelation succeed",
      regenerate: "Regenerate another signature request",
      regenerateSuccess: "Signature regenerated",
    },
    bonusTransfer: {
      title: "Bonus",
      offer: "Offer: {label}",
      expirationDate: "Bonus expiration date: {date}",
      IBANreceiptDate: "IBAN receipt date: {date}",
      resendMessage: "Resend Email IBAN entry",
      externalTransfer: {
        text: "Swan transfer : {id} ({status})",
        status: {
          [ESiteBonusTransferStatus.INITIALIZED]: "Initialized",
          [ESiteBonusTransferStatus.SUBMISSION_ERROR]: "Submission error",
          [ESiteBonusTransferStatus.CONSENT_ERROR]: "Consent error",
          [ESiteBonusTransferStatus.PENDING]: "Pending",
          [ESiteBonusTransferStatus.REJECTED]: "Rejected",
          [ESiteBonusTransferStatus.SUBMITTED]: "Submitted",
          [ESiteBonusTransferStatus.BOOKED]: "Booked",
          [ESiteBonusTransferStatus.NONEXISTENT]: "None",
        },
      },
    },
  },
};

export default installationFlowLocale;
